import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Save, Loader2 } from 'lucide-react';

const PRESET_PALETTES = [
  { name: 'الزيتون (الافتراضي)', primary: '#C19A6B', accent: '#5D4037', secondary: '#3A5F0B' },
  { name: 'الأخضر العماني', primary: '#2E7D32', accent: '#1B5E20', secondary: '#43A047' },
  { name: 'الأزرق الملكي', primary: '#1565C0', accent: '#0D47A1', secondary: '#42A5F5' },
  { name: 'البنفسجي', primary: '#7B1FA2', accent: '#4A148C', secondary: '#AB47BC' },
  { name: 'العنابي', primary: '#AD1457', accent: '#880E4F', secondary: '#EC407A' },
  { name: 'التركواز', primary: '#00897B', accent: '#004D40', secondary: '#26A69A' },
];

const ThemeEditor = ({ themeColors, setThemeColors, saveTheme, savingTheme }) => (
  <div className="space-y-6">
    <p className="text-sm text-muted-foreground">اختر ألوان المنصة. سيتم تطبيقها فوراً على جميع الصفحات.</p>

    <div>
      <label className="block text-sm font-medium mb-3">ألوان جاهزة</label>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {PRESET_PALETTES.map((p, i) => (
          <button key={i} onClick={() => setThemeColors({ primary: p.primary, accent: p.accent, secondary: p.secondary })}
            className="flex items-center gap-3 p-3 rounded-xl border-2 transition-all hover:shadow-md text-right"
            style={{ borderColor: themeColors.primary === p.primary ? p.primary : '#e5e7eb' }}
            data-testid={`palette-${i}`}>
            <div className="flex gap-1 shrink-0">
              <div className="w-6 h-6 rounded-full" style={{backgroundColor: p.primary}} />
              <div className="w-6 h-6 rounded-full" style={{backgroundColor: p.accent}} />
            </div>
            <span className="text-sm font-medium">{p.name}</span>
          </button>
        ))}
      </div>
    </div>

    <div>
      <label className="block text-sm font-medium mb-3">ألوان مخصصة</label>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { key: 'primary', label: 'اللون الرئيسي (الأزرار والروابط)' },
          { key: 'accent', label: 'لون النصوص (العناوين والخلفيات)' },
          { key: 'secondary', label: 'اللون الثانوي' },
        ].map(({ key, label }) => (
          <div key={key} className="space-y-2">
            <label className="text-xs text-muted-foreground">{label}</label>
            <div className="flex items-center gap-3 p-3 border rounded-xl">
              <input type="color" value={themeColors[key]} onChange={e => setThemeColors(prev => ({...prev, [key]: e.target.value}))}
                className="w-10 h-10 rounded-lg cursor-pointer border-0" data-testid={`color-${key}`} />
              <Input value={themeColors[key]} onChange={e => setThemeColors(prev => ({...prev, [key]: e.target.value}))}
                className="flex-1 font-mono text-sm" dir="ltr" />
            </div>
          </div>
        ))}
      </div>
    </div>

    <div>
      <label className="block text-sm font-medium mb-3">معاينة</label>
      <div className="p-6 rounded-2xl border-2" style={{borderColor: `${themeColors.primary}30`}}>
        <div className="flex items-center gap-4 mb-4">
          <div className="px-5 py-2.5 rounded-xl text-white font-semibold" style={{backgroundColor: themeColors.primary}}>زر رئيسي</div>
          <div className="px-5 py-2.5 rounded-xl border-2 font-semibold" style={{borderColor: themeColors.primary, color: themeColors.primary}}>زر ثانوي</div>
        </div>
        <h3 className="text-xl font-bold mb-2" style={{color: themeColors.accent}}>عنوان تجريبي</h3>
        <p className="text-sm" style={{color: `${themeColors.accent}99`}}>هذا نص تجريبي لمعاينة شكل الألوان في الموقع.</p>
      </div>
    </div>

    <Button onClick={saveTheme} disabled={savingTheme} className="w-full bg-primary hover:bg-primary/90" data-testid="save-theme-btn">
      {savingTheme ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4 ml-2" /> حفظ الألوان</>}
    </Button>
  </div>
);

export default ThemeEditor;
